import { useCallback } from 'react'

import { useTranslation } from 'services/i18n'

export const useTitle = () => {
  const { t } = useTranslation()

  const updateTitle = useCallback(
    (text?: string) => {
      const platformTitle = t('platform_name')
      const titleQuerySelector = document.querySelector('title')
      const title = titleQuerySelector ?? document.createElement('title')

      if (!titleQuerySelector) {
        document.head.appendChild(title)
      }

      title.innerText = text ? `${platformTitle} - ${text}` : platformTitle
    },
    [t],
  )

  return { updateTitle }
}
